export const weekdaySchedule = [
  {
    time: "14:00",
    title: "阿飞正传",
    year: "1990",
    era: "九十年代",
    duration: "94 分钟",
    hall: "一号厅 · 怀旧专场",
    tag: "文艺",
  },
  {
    time: "15:50",
    title: "赌神",
    year: "1989",
    era: "八十年代末",
    duration: "126 分钟",
    hall: "二号厅 · 港片经典",
    tag: "娱乐",
  },
  {
    time: "18:10",
    title: "倩女幽魂",
    year: "1987",
    era: "八十年代末",
    duration: "98 分钟",
    hall: "一号厅 · 古装奇幻",
    tag: "奇幻",
  },
  {
    time: "20:00",
    title: "英雄本色",
    year: "1986",
    era: "八十年代",
    duration: "95 分钟",
    hall: "三号厅 · 黄金年代",
    tag: "动作",
  },
  {
    time: "21:45",
    title: "新龙门客栈",
    year: "1992",
    era: "九十年代",
    duration: "88 分钟",
    hall: "二号厅 · 武侠之夜",
    tag: "武侠",
  },
];

export const weekendSchedule = [
  {
    time: "11:00",
    title: "逃学威龙",
    year: "1991",
    era: "九十年代",
    duration: "101 分钟",
    hall: "二号厅 · 周末欢乐场",
    tag: "喜剧",
  },
  {
    time: "13:10",
    title: "纵横四海",
    year: "1991",
    era: "九十年代",
    duration: "108 分钟",
    hall: "一号厅 · 港片经典",
    tag: "动作",
  },
  {
    time: "15:30",
    title: "黄飞鸿",
    year: "1991",
    era: "九十年代",
    duration: "134 分钟",
    hall: "三号厅 · 武侠展映",
    tag: "武侠",
  },
  {
    time: "18:20",
    title: "唐伯虎点秋香",
    year: "1993",
    era: "九十年代",
    duration: "102 分钟",
    hall: "二号厅 · 合家欢",
    tag: "喜剧",
  },
  {
    time: "20:15",
    title: "大话西游",
    year: "1995",
    era: "九十年代",
    duration: "95 分钟",
    hall: "一号厅 · 午夜经典",
    tag: "奇幻",
  },
  {
    time: "22:10",
    title: "甜蜜蜜",
    year: "1996",
    era: "九十年代",
    duration: "118 分钟",
    hall: "三号厅 · 都市情感",
    tag: "爱情",
  },
];